import hatStyles from "../1-style/hatStyles";
import disableSwatches from "../3-hat-color/disableSwatches";
import selectAllElements from "../dom/selectAllElements";
import { DROP_ITEM } from "./_selectors";
import { toggleDescription } from "./toggleDescription";

function materialSwatchSetup() {
	const materialSwatch = selectAllElements(DROP_ITEM);
	let previousMaterial = hatStyles.snapback.materials.wool.label;
	if (materialSwatch !== null) {
		for (const material of materialSwatch) {
			material.addEventListener("click", function (e) {
				const target = e.target as HTMLElement;
				const material = String(target.dataset.value);
				console.log({
					previousMaterial,
					material,
				});
				toggleDescription(previousMaterial, material);
				disableSwatches(material);
				previousMaterial = material;
			});
		}
	}
}

export default materialSwatchSetup;
